import { T_HEADER_PAGE_CONSTANTS } from './TYPES'

const DE_HEADER_PAGE_CONSTANTS: T_HEADER_PAGE_CONSTANTS = {
  PROFILE_TEXT: 'Profil',
  LOGOUT_TEXT: 'Abmelden'
}

export default DE_HEADER_PAGE_CONSTANTS
